export interface EnumValueDto {
  value: string;
  name: string;
  displayName: string;
}
